import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NAME, selectAll, selectEntities, State } from './print-template.reducer';

export const selectPrintTemplateState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectPrintTemplateState, (state: State) => state.error);

export const getLoaded = createSelector(selectPrintTemplateState, (state: State) => state.loaded);

export const getAll = createSelector(selectPrintTemplateState, selectAll);

export const getAllEntities = createSelector(selectPrintTemplateState, selectEntities);

export const getByMethodId = (props: { methodId: number }) =>
  createSelector(getAll, (templates) => templates.filter((template) => template.methodId === props.methodId));
